import { useCallback, useState } from 'react';

const STORAGE_KEY = '__pdfgenius_payment__';

type WindowStore = Record<string, any>;

const readStore = (): WindowStore => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as WindowStore) : {};
  } catch {
    return {};
  }
};

const writeStore = (data: WindowStore) => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // no-op
  }
};

export function useWindowData<T>(key: string) {
  const [data, setDataState] = useState<T | undefined>(() => {
    const store = readStore();
    return store[key] as T | undefined;
  });

  const setData = useCallback(
    (value: T | undefined | null) => {
      setDataState(value ?? undefined);
      const store = readStore();
      if (value === undefined || value === null) {
        delete store[key];
      } else {
        store[key] = value;
      }
      writeStore(store);
    },
    [key]
  );

  return { data, setData };
}
